function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { fontRegular } from '../../theme/fonts';
import { size8, size16, size18 } from '../../theme/scale';
import ColorWrapper from '../color-wrapper';
export const Wrapper = styled(ColorWrapper)`
  display: flex;
  flex-direction: ${({
  horizontal
}) => horizontal ? 'row' : 'column'};
  font-family: ${fontRegular};
  font-size: ${size16};
  line-height: 1.5;
  margin: 0;
  padding-left: ${size18};
  ${({
  unstyled
}) => unstyled && 'list-style: none; padding: 0;'}
  ${({
  marginBottom
}) => marginBottom && `margin-bottom: ${size16};`}

  > li {
    &:not(:last-of-type) {
      ${({
  horizontal
}) => horizontal ? `margin-right: ${size8};` : `margin-bottom: ${size8};`}
    }
  }
`;
export const List = ({
  children,
  element = 'ul',
  unstyled = false,
  horizontal = false,
  marginBottom = false,
  ...props
}) => /*#__PURE__*/React.createElement(Wrapper, _extends({
  unstyled,
  horizontal,
  marginBottom
}, props, {
  as: element
}), children);
export default List;
//# sourceMappingURL=index.js.map